<div
  class="text-field df-c"
  [class.text-field--filled]="isFilled()"
  [class.text-field--disabled]="disabled()"
  [class.text-field--size-small]="size() === 'small'"
>
  @if (label()) {
    <span class="text-field__label typography-labels-2">
      {{ label() }}
    </span>
  }

  <div class="text-field__field">
    @if (leftIcon(); as icon) {
      <div class="text-field__icon-wrapper">
        <fr8bot-ui-icon [name]="icon" [size]="16" class="text-field__icon text-field__left-icon" />
      </div>
    }

    <input
      #inputElement
      [value]="text()"
      [placeholder]="placeholder() ?? ''"
      [disabled]="disabled()"
      (input)="onInput(inputElement)"
      (blur)="touch.emit()"
      class="typography-labels-2"
    />

    @if (rightIcon() && !isFilled()) {
      <span
        class="text-field__action tw:flex tw:w-[var(--field-action-size,48px)] tw:h-full tw:shrink-0 tw:items-center tw:justify-center"
      >
        <fr8bot-ui-icon
          [size]="16"
          name="visible-yes-16"
          class="text-field__icon text-field__right-icon"
        />
      </span>
    }

    @if (isFilled() && !disabled()) {
      <button uiFieldAction="danger" class="text-field__action" (click)="clear()">
        <fr8bot-ui-icon [size]="16" name="x-1-16" />
      </button>
    }
  </div>
</div>
